<script>
</script>
<template>
  <div>
    <PageAllow controller="StockOuts" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4" v-if="pageType == 1 || pageType == 2">
          <v-row dense align="center" class="pa-1 pe-2">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              deleteIcon
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="4" v-else>
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('StockOrderOUT.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>

            <v-col>
              <!--              !!! 出库数量撤回功能弃用 触发按钮隐藏 !!!-->
              <!--              <v-btn-->
              <!--                v-if="-->
              <!--                  pageType == 2 &&-->
              <!--                  $permission.permissionAllow('StockOuts', 'batchOutNumRecall')-->
              <!--                "-->
              <!--                small-->
              <!--                color="warning"-->
              <!--                class="ms-1 float-end"-->
              <!--                @click.stop="outRecallDialog = true"-->
              <!--              >-->
              <!--                {{ $t("StockOrderOUT.actions.outNumRecall") }}-->
              <!--              </v-btn>-->
              <v-btn
                v-if="
                  pageType != 3 &&
                  $permission.permissionAllow('StockOuts', 'add')
                "
                small
                color="primary"
                href="/#/stock-orders-out/new"
                class="ms-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("StockOrderOUT.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  settings.stock_position_setting &&
                  $permission.permissionAllow('Waves', 'getConfirmWaveDetail')
                "
                small
                color="action"
                dark
                class="ms-1 float-end"
                @click.stop="
                  pageType == 3
                    ? $router.push('/production-stock-out/stock-pack-confirm')
                    : pageType == 2
                    ? $router.push('/order-stock-out/stock-pack-confirm')
                    : $router.push('/stock-orders-out/stock-pack-confirm')
                "
              >
                <v-icon x-small class="pe-1">fa-box</v-icon>
                {{ $t("StockOrderOUT.actions.packConfirm") }}
              </v-btn>
              <span
                v-if="
                  pageType != 3 &&
                  (stockOutTypeSelected == 1 ||
                    $route.path.startsWith('/order-stock-out'))
                    ? true
                    : false
                "
              >
                <!-- 批量手动拆单 -->
                <v-btn
                  v-if="
                    settings &&
                    !settings.stock_position_setting &&
                    $permission.permissionAllow('StockOuts', 'manualSplit')
                  "
                  small
                  color="primary"
                  class="ms-1 float-end"
                  @click.stop="routerManualSplit()"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("StockOrderOUT.actions.batchManualSplit") }}
                </v-btn>
                <!-- 批量分拣出库 -->
                <v-btn
                  v-if="
                    settings &&
                    !settings.stock_position_setting &&
                    $permission.permissionAllow('StockOuts', 'batchSortingOut')
                  "
                  small
                  color="primary"
                  class="ms-1 float-end"
                  @click.stop="routerPickingOut()"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("StockOrderOUT.actions.batchPickingOut") }}
                </v-btn>
                <v-btn
                  v-if="$permission.permissionAllow('StockOuts', 'batchOut')"
                  small
                  color="warning"
                  class="ms-1 float-end"
                  @click="batchOutDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                  {{ $t("StockOrderOUT.actions.batchOut") }}
                </v-btn>
              </span>
              <!-- 批量云打印 -->
              <v-menu
                v-if="
                  pageType != 3 &&
                  ($permission.permissionAllow('Distributions', 'prints') ||
                    ($permission.permissionAllow(
                      'StockOuts',
                      'shopDistributionsPrint'
                    ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)) ||
                    $permission.permissionAllow(
                      'StockOuts',
                      'stockOrdersPrint'
                    )) &&
                  $permission.permissionAllow('CloudPrints', 'index') &&
                  settings &&
                  settings.cloud_print_enable
                "
                v-model="cloudPrintBtnMenu"
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-print</v-icon>
                    {{ $t("Print.batch_cloud_print") }}
                    <v-icon x-small class="ps-1">{{
                      cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Distributions', 'prints')
                    "
                    @click="doCloudPrint('distribution')"
                  >
                    <v-list-item-title>
                      {{
                        $t("StockOrderOUT.actions.distrubitionBtachPrePrint")
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <!--                  <v-list-item-->
                  <!--                    v-if="-->
                  <!--                      $permission.permissionAllow(-->
                  <!--                        'StockOuts',-->
                  <!--                        'shopDistributionsPrint'-->
                  <!--                      ) &&-->
                  <!--                      (stockOutTypeSelected == 1 || pageType == 2)-->
                  <!--                    "-->
                  <!--                    @click="doCloudPrint('commonShopDistribution')"-->
                  <!--                  >-->
                  <!--                    <v-list-item-title>-->
                  <!--                      {{ $t("StockOrderOUT.actions.distrubitionsMergePrint") }}-->
                  <!--                    </v-list-item-title>-->
                  <!--                  </v-list-item>-->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'stockOrdersPrint'
                      )
                    "
                    @click="doCloudPrint('stockOrderOut')"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.stockOUTOrdersPrint") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 批量打印 -->
              <v-menu
                v-if="
                  pageType != 3 &&
                  ($permission.permissionAllow('Distributions', 'prints') ||
                    ($permission.permissionAllow(
                      'StockOuts',
                      'shopDistributionsPrint'
                    ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)) ||
                    $permission.permissionAllow(
                      'StockOuts',
                      'stockOrdersPrint'
                    ))
                "
                v-model="printBtnMenu"
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-print</v-icon>
                    {{ $t("Print.batchPrint") }}
                    <v-icon x-small class="ps-1">{{
                      printBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Distributions', 'prints')
                    "
                    @click="doPrint('distributionPrint')"
                  >
                    <v-list-item-title>
                      {{
                        $t("StockOrderOUT.actions.distrubitionBtachPrePrint")
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'shopDistributionsPrint'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    @click="doPrint('distributionsMergePrint')"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.distrubitionsMergePrint") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-menu
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'shopStockOrdersPrint'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    open-on-hover
                    top
                    offset-x
                    :close-on-content-click="false"
                    :nudge-bottom="50"
                    :nudge-left="10"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-title> {{ $t("StockOrderOUT.actions.stockOUTOrdersMergePrint") }}</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-if="
                          $permission.permissionAllow(
                          'StockOuts',
                          'shopStockOrdersPrint'
                          ) &&
                          (stockOutTypeSelected == 1 || pageType == 2)
                        "
                        @click="doPrint('stockOUTOrdersMergePrintPreview')"
                      >
                        <v-list-item-title>
                          {{ $t("StockOrderOUT.actions.stockOUTOrdersMergePrintPreview") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          $permission.permissionAllow(
                          'StockOuts',
                          'shopStockOrdersPrint'
                          ) &&
                          (stockOutTypeSelected == 1 || pageType == 2)
                        "
                        @click="doPrint('stockOUTOrdersMergePrint')"
                      >
                        <v-list-item-title>
                          {{ $t("StockOrderOUT.actions.stockOUTOrdersMergePrint") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'stockOrdersPrint'
                      )
                    "
                    @click="doPrint('stockOUTOrdersPrint')"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.stockOUTOrdersPrint") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-menu
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'requisitionOutMergePrint'
                      ) &&
                      stockOutTypeSelected == 2 &&
                      pageType == 1
                    "
                    open-on-hover
                    top
                    offset-x
                    :close-on-content-click="false"
                    :nudge-bottom="50"
                    :nudge-left="10"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-title>{{ $t("StockOrderOUT.actions.requisitionOutMergePrint") }}</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-list dense>
                      <v-list-item @click="doPrint('requisitionOutMergePrintPreview')">
                        <v-list-item-title>
                          {{ $t("StockOrderOUT.actions.requisitionOutMergePrintPreview") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="doPrint('requisitionOutMergePrint')">
                        <v-list-item-title>
                          {{ $t("StockOrderOUT.actions.requisitionOutMergePrint") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list>
              </v-menu>
              <!-- 批量导出 -->
              <v-menu
                v-model="exportBtnMenu"
                close-on-click
                close-on-content-click
                offset-y
                v-if="
                  $permission.permissionAllow(
                    'StockOuts',
                    'batchDetailPriceExport'
                  ) ||
                  $permission.permissionAllow(
                    'StockOuts',
                    'distributionDetailBatchExport'
                  ) ||
                  ((stockOutTypeSelected == 1 || pageType == 2) &&
                    ($permission.permissionAllow(
                      'StockOuts',
                      'shopMergeExport'
                    ) ||
                      $permission.permissionAllow(
                        'StockOuts',
                        'materialMergeExport'
                      ) ||
                      $permission.permissionAllow(
                        'StockOuts',
                        'disUserMergeExport'
                      ) ||
                      $permission.permissionAllow(
                        'StockOuts',
                        'batchDetailPriceSubAccountExport'
                      )))
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-file-export</v-icon>
                    {{ $t("Export.batchExport") }}
                    <v-icon x-small class="ps-1">{{
                      exportBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'batchDetailPriceExport'
                      )
                    "
                    @click="batchExport()"
                  >
                    <v-list-item-title>
                      {{
                        $t("Export.export", [$t("StockOrderOUT.ObjectName")])
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'batchDetailPriceSubAccountExport'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    @click="batchDetailPriceSubAccountExport()"
                  >
                    <v-list-item-title>
                      {{
                        $t("Export.export", [
                          $t("StockOrderOUT.batchDetailPriceSubAccountExport"),
                        ])
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'distributionDetailBatchExport'
                      )
                    "
                    @click="batchDistributionsExport()"
                  >
                    <v-list-item-title>
                      {{
                        $t("Export.export", [$t("StockOrderOUT.distribution")])
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'shopMergeExport'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    @click="shopMergeExport()"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.shopMergeExport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'materialMergeExport'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    @click="materialMergeExport()"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.materialMergeExport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'disUserMergeExport'
                      ) &&
                      (stockOutTypeSelected == 1 || pageType == 2)
                    "
                    @click="disUserMergeExport()"
                  >
                    <v-list-item-title>
                      {{ $t("StockOrderOUT.actions.disUserMergeExport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'requisitionMergeExport'
                      ) &&
                      stockOutTypeSelected == 2 &&
                      pageType == 1
                    "
                    @click="requisitionMergeExport()"
                  >
                    <v-list-item-title>
                      {{
                          $t("StockOrderOUT.requisitionMergeExport"),
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'sortingMaterialMergeExport'
                      ) && pageType == 1
                    "
                    @click="sortingMaterialMergeExport()"
                  >
                    <v-list-item-title>
                      {{
                          $t("StockOrderOUT.sortingMaterialMergeExport"),
                      }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockOutsKeyWord = $event"
                  :label="
                    stockOutTypeSelected == 1 || pageType == 2
                      ? $t('StockOrderOUT.stockOutsKeyword_two')
                      : $t('StockOrderOUT.stockOutsKeyword')
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <SearcherKeyword
                  ref="ext_code"
                  v-model="options.ext_code"
                  @text="extCodeKeyword = $event"
                  :label="$t('StockOrderOUT.Fields.ext_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <SearcherStocks
                  v-model="stocksSelected"
                  @change="distributionUserSelected = null"
                  :stock-types="[0]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-else-if="pageType == 2">
                <SearcherStock
                  v-model="stockSelected"
                  showVirtualStock
                  @change="distributionUserSelected = null"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-else>
                <SearcherStock v-model="stockSelected" :stock-types="[0]" />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <v-select
                  v-model="stockOutTypeSelected"
                  clearable
                  :items="
                    $consts.stock_out_order.types.filter(
                      (element) => element.value != 4
                    )
                  "
                  :label="$t('StockOrderOUT.Fields.stock_out_type')"
                >
                </v-select>
              </v-col>
              <!-- 调拨出库 下 调入仓库 -->
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="pageType == 1 && stockOutTypeSelected == 2"
              >
                <SearcherStocks
                    v-model="requisitionStocksSelected"
                    :stock-types="[0]"
                    :label="$t('StockOrderOUT.Fields.requisition_to_stock')"
                />
              </v-col>
              <!-- 报损理由 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="pageType == 1 && stockOutTypeSelected == 11"
              >
                <v-select
                  v-model="stockOutBrokenTypeSelected"
                  clearable
                  :items="$consts.stock_out_order.brokenType"
                  :label="$t('StockOrderOUT.Fields.broken_type')"
                >
                </v-select>
              </v-col>
              <!-- 商品分类 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType != 3 && (stockOutTypeSelected == 1 || pageType == 2)
                "
              >
                <SearcherMaterialCategoriesWithDescendants
                  v-model="materialCategoriesSelected"
                />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
              <!-- 配送路线 -->
              <v-col cols="12" sm="6" md="4" v-if="pageType == 2">
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  mustStockId
                  :stockId="stockSelected ? stockSelected.id : 0"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-else-if="pageType == 1 && stockOutTypeSelected == 1"
              >
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  mustStockId
                  :stockId="
                    stocksSelected && stocksSelected.length
                      ? options.stock_ids
                      : 0
                  "
                />
              </v-col>
              <!-- 仓库组别 -->
              <v-col cols="12" sm="6" md="4" v-if="pageType == 2">
                <SearcherStockDistrict v-model="stockDistrictSelected" />
              </v-col>
              <!-- 客户 -->
              <!--              <v-col-->
              <!--                cols="12"-->
              <!--                sm="6"-->
              <!--                md="4"-->
              <!--                v-if="-->
              <!--                  pageType != 3 && (stockOutTypeSelected == 1 || pageType == 2)-->
              <!--                "-->
              <!--              >-->
              <!--                <SearcherShops v-model="shopsSelected" />-->
              <!--              </v-col>-->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType != 3 && (stockOutTypeSelected == 1 || pageType == 2)
                "
              >
                <SearcherKeyword
                  ref="shop_keyword"
                  v-model="options.shop_keyword"
                  @text="shopKeyword = $event"
                  :label="$consts.shopName()"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType != 3 && (stockOutTypeSelected == 1 || pageType == 2)
                "
              >
                <SearcherDistrictsWithDescendants
                  v-model="districtsSelected"
                  :label="$t('Shop.shopDistrict', [$consts.shopName()])"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType != 3 &&
                  (stockOutTypeSelected == 1 || pageType == 2) &&
                  settings &&
                  settings.delivery_point &&
                  $permission.permissionAllow('DeliveryPoints', 'index')
                "
              >
                <SearcherDeliveryPoint v-model="deliveryPointSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('StockOrderOUT.status.title')"
                  :items="
                    pageType == 1 && stockOutTypeSelected != 1
                      ? $consts.stock_out_order.status
                      : [
                          $consts.stock_out_order.status[1],
                          $consts.stock_out_order.status[2],
                        ]
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 2">
                <SearcherStatus
                  v-model="options.pay_flgs"
                  :items="$consts.bill.pay_flgs"
                  :label="$t('Bill.payFlgs.title')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  pageType == 1 &&
                  (stockOutTypeSelected == 1 ||
                    $route.path.startsWith('/order-stock-out'))
                "
              >
                <SearcherStatus
                  v-model="options.is_print"
                  :label="$t('StockOrderOUT.is_print.title')"
                  :items="$consts.stock_out_order.is_print"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  $permission.permissionAllow('PresaleTemplates', 'index') &&
                  settings &&
                  settings.presale_enable &&
                  (pageType == 2 ||
                    (stockOutTypeSelected == 1 && pageType == 1))
                "
              >
                <SearcherStatus
                  v-model="options.presale_flgs"
                  :label="$t('Order.presale_flgs.title')"
                  :items="$consts.order.presale_flg"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_outs"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:header.stock_order_code="{ header }">
            <span v-if="options.datetimeRadioSelected == 'created'">
              {{ header.text }}
            </span>
            <span v-else-if="options.datetimeRadioSelected == 'order'">
              {{
                $t("StockOrderOUT.Fields.stock_out_code") +
                " / " +
                $t("StockOrderOUT.Fields.order_time")
              }}
            </span>
            <span v-else-if="options.datetimeRadioSelected == 'actual'">
              {{
                $t("StockOrderOUT.Fields.stock_out_code") +
                " / " +
                $t("StockOrderOUT.Fields.actual_time")
              }}
            </span>
            <span v-else-if="options.datetimeRadioSelected == 'finish'">
              {{
                $t("StockOrderOUT.Fields.stock_out_code") +
                " / " +
                $t("StockOrderOUT.Fields.finished_time")
              }}
            </span>
            <span v-else-if="options.datetimeRadioSelected == 'expect'">
              {{
                $t("StockOrderOUT.Fields.stock_out_code") +
                " / " +
                $t("StockOrderOUT.Fields.expect_time")
              }}
            </span>
            <span v-else-if="pageType == 3">
              {{ header.text }}
            </span>
          </template>
          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold d-inline-flex align-center"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
              <v-img
                v-if="item.origin_id != 0"
                :src="require('@/assets/chaxun.png')"
                max-height="15"
                max-width="15"
                class="d-inline-block ml-1"
                @click.stop="
                  currentItem = item;
                  getPartOutRelations();
                  partOutDialog = true;
                "
              ></v-img>
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              <span v-if="options.datetimeRadioSelected == 'created'">
                {{ item.created | formatTime }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'order'">
                {{ item.order_created | formatTime }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'actual'">
                {{ item.actual_date | formatTime }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'finish'">
                {{ item.finish_time | formatTime }}
              </span>
              <span v-else-if="options.datetimeRadioSelected == 'expect'">
                {{ item.expect_date | formatTime }}
              </span>
              <span v-else-if="pageType == 3">
                {{ item.created | formatTime }}
              </span>
            </span>
          </template>

          <template v-slot:item.type="{ item }">
            <v-chip
              small
              label
              :color="item.type | stockOrderOUTTypesColor"
              :text-color="item.type | stockOrderOUTTypesTextColor"
            >
              {{ item.type | stockOrderOUTTypesText }}
            </v-chip>
            <br />
            <a
              v-if="item.type == 1"
              class="text-no-wrap text-caption"
              :href="'/#/orders/' + item.order_id"
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
            <a
              v-if="item.type == 2 && item.out_requisition && item.out_requisition.requisition_code"
              class="text-no-wrap text-caption"
              :href="'/#/requisitions/' + item.out_requisition.id"
              style="text-decoration: none"
            >
              {{ item.out_requisition.requisition_code }}
            </a>
          </template>

          <template v-slot:item.print_count="{ item }">
            <span v-if="item.print_count > 0" class="primary--text">
              {{ $t("StockOrderOUT.Fields.printCount", [item.print_count]) }}
            </span>
            <span v-else class="red--text">
              {{ $t("StockOrderOUT.Fields.printNone") }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | stockOrderOUTStatusColor"
              :text-color="item.status | stockOrderOUTStatusTextColor"
            >
              {{ item.status | stockOrderOUTStatusText }}
              <span
                v-if="
                  item.third_return && item.third_return.push_platform == 1010
                "
              >
                ({{ item.third_return.status | stockOrderOUTThirdStatusText }})
              </span>
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <template v-slot:item.presale_flg="{ item }">
            <v-chip
              small
              label
              :color="item.presale_flg | presaleFlgsColor"
              :text-color="item.presale_flg | presaleFlgsTextColor"
              >{{ item.presale_flg | presaleFlgsText }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- 操作 -->
            <StockOrderOUTActions
              :productionFlg="pageType == 3"
              :orderFlg="pageType == 2"
              :stock_out="item"
              showView
              showSortingOut
              :showEdit="item.actions.out_edit"
              :showApprove="item.actions.out_approve"
              :showCancel="item.actions.out_cancel"
              :showComplete="item.actions.out_complete"
              :showSheetPrint="item.actions.sheet_print"
              :showCloudPrint="item.actions.sheet_print"
              @done="getStockOutsFromAPI()"
              @packConfirm="completePackConfirm($event)"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 批量出库 -->
    <DialogAlert
      v-model="batchOutDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('StockOrderOUT.Messages.batchOutAlert')"
      persistent
      useConfirm
      @confirm="
        batchOutDialog = false;
        batchOutInfoDialog = true;
        batchOut(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchOutInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchOutInfo"
      persistent
      :closable="errorCount > 0"
    />
    <!-- 部分出库 -->
    <v-dialog v-model="partOutDialog" max-width="300px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("StockOrderOUT.Fields.stock_out_part") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="partOutDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <v-data-table
            :headers="partHeaders"
            :items="part_stock_outs"
            multi-sort
            hide-default-header
            hide-default-footer
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="partOutDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogAlert
      v-model="outRecallDialog"
      :message="$t('StockOrderOUT.Messages.outRecallAlert')"
      useConfirm
      @confirm="batchOutNumRecall()"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockOuts from "@/api/stock_outs";
import StockOrderOUTActions from "./plugins/Actions";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherDeliveryPoint from "@/components/plugins/SearcherDeliveryPoint";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
// import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import makeData from "../distributions/makeData";

let intervalRef = void 0;

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  finish_time_from: "",
  finish_time_to: "",
  stock_order_code: "",
  status: [1, 2],
  cancel_flgs: [0],
  type: null,
  broken_type: null,
  stock_ids: null,
  is_print: [1, 0],
  district_ids: [],
  shop_ids: [],
  shop_keyword: "",
  material_ids: [],
  category_codes: [],
  delivery_point_id: null,
  distribution_user_id: null, //配送线路
  presale_flgs: [0, 1],
  requisition_to_stock_ids: null,
};

const defaultProductionOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  status: [2],
  cancel_flgs: [0],
  type: 4,
  stock_ids: null,
  material_ids: [],
};

const defaultOrdersOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  order_time_from: "",
  order_time_to: "",
  actual_time_from: "",
  actual_time_to: "",
  finish_time_from: "",
  finish_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  stock_order_code: "",
  status: [2],
  cancel_flgs: [0],
  type: 1,
  stock_ids: null,
  district_ids: [],
  pay_flgs: [1, 2, 3],
  distribution_user_id: null, //配送线路
  is_print: [1, 0],
  stock_district_id: null, //仓库分组
  shop_ids: [],
  shop_keyword: "",
  material_ids: [],
  delivery_point_id: null,
  presale_flgs: [0, 1],
};

function getPageType() {
  return document.URL.endsWith("/production-stock-out")
    ? 3
    : document.URL.endsWith("/order-stock-out")
    ? 2
    : 1;
}
function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 1:
      return "stock-orders-out";
    case 2:
      return "order-stock-out";
    case 3:
      return "production-stock-out";
  }
}
function getOptionSelects() {
  switch (getPageType()) {
    default:
    case 1:
      return [
        "stockOutTypeSelected",
        "shopsSelected",
        "stocksSelected",
        "requisitionStocksSelected",
        "districtsSelected",
        "deliveryPointSelected",
        "materialSelected",
        "materialCategoriesSelected",
        "distributionUserSelected",
      ];
    case 2:
      return [
        "stockSelected",
        "districtsSelected",
        "deliveryPointSelected",
        "distributionUserSelected",
        "shopsSelected",
        "stockDistrictSelected",
        "materialSelected",
      ];
    case 3:
      return ["stockSelected", "materialSelected"];
  }
}
function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 1:
      return defaultOptions;
    case 2:
      return defaultOrdersOptions;
    case 3:
      return defaultProductionOptions;
  }
}

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderOUTActions,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStock,
    SearcherStocks,
    SearcherStatus,
    SearcherCancelFlgs,
    DialogAlert,
    BatchOperationInfoAlert,
    SearcherDistrictsWithDescendants,
    SearcherDeliveryPoint,
    SearcherDistributionUser,
    // SearcherShops,
    SearcherStockDistrict,
    SearcherMaterials,
    SearcherDatetimeRangeWithRadio,
    SearcherMaterialCategoriesWithDescendants,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text:
            this.pageType == 3
              ? i18n.t("Nav.productionManagement")
              : this.pageType == 2
              ? i18n.t("Nav.orderManagement")
              : this.pageType == 1
              ? i18n.t("Nav.stockManagement")
              : "",
          disabled: false,
          replace: true,
          href:
            this.pageType == 3
              ? "/production-plans"
              : this.pageType == 2
              ? "/orders"
              : this.pageType == 1
              ? "/stocks"
              : "",
        },
        {
          text:
            this.pageType == 3
              ? i18n.t("Nav.productionStockOUT")
              : this.pageType == 2
              ? i18n.t("Nav.ordersStockOrdersOut")
              : this.pageType == 1
              ? i18n.t("Nav.stockOrdersOut")
              : "",
          disabled: true,
          href: "/stockOrdersOut",
        },
      ];
    },
    headers() {
      let item = [
        {
          text:
            i18n.t("StockOrderOUT.Fields.stock_out_code") +
            " / " +
            i18n.t("StockOrderOUT.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
      ];
      if (getPageType() != 3) {
        item.push({
          text: i18n.t("StockOrderOUT.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        });
      }
      item.push(
        {
          text: i18n.t("StockOrderOUT.Fields.stock_out_type"),
          align: "start",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.detail_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "details_count",
        }
      );
      if (this.pageType == 2 || this.pageType == 1) {
        item.push({
          text: i18n.t("StockOrderOUT.Fields.print_count"),
          align: "start",
          sortable: false,
          value: "print_count",
        });
      }
      item.push({
        text: i18n.t("StockOrderOUT.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      });
      if (
        this.$permission.permissionAllow("PresaleTemplates", "index") &&
        this.settings &&
        this.settings.presale_enable &&
        (this.pageType == 2 || (this.pageType == 1 && this.stockOutTypeSelected == 1))
      ) {
        item.push({
          text: i18n.t("Order.Fields.presale_flg"),
          align: "center",
          sortable: false,
          value: "presale_flg",
        });
      }
      item.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });
      return item;
    },
    partHeaders() {
      return [
        {
          text:
            i18n.t("StockOrderOUT.Fields.stock_out_code") +
            " / " +
            i18n.t("StockOrderOUT.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: "",
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "status_str",
        },
      ];
    },
    datetimeRadios() {
      let radio = [
        {
          key: "created",
          text: i18n.t("StockOrderOUT.Fields.created_time"),
        },
      ];
      if (this.pageType == 2) {
        radio.push({
          key: "order",
          text: i18n.t("StockOrderOUT.Fields.order_time"),
        });
      }
      radio.push(
        {
          key: "actual",
          text: i18n.t("StockOrderOUT.Fields.actual_time"),
        },
        {
          key: "finish",
          text: i18n.t("StockOrderOUT.Fields.finished_time"),
        }
      );
      if (this.pageType == 2) {
        radio.push({
          key: "expect",
          text: i18n.t("StockOrderOUT.Fields.expect_time"),
        });
      }
      return radio;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols", "accountUser"]),
  },

  data: () => ({
    pageType: getPageType(),
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    exportBtnMenu: false,
    stockOutsKeyWord: "",
    stockOutTypeSelected: null,
    stockOutBrokenTypeSelected: null,
    stockSelected: null,
    stocksSelected: [],
    requisitionStocksSelected: [],
    stock_outs: [],
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    detailMode: false,
    btnPrintMenu: false,
    btnExportMenu: false,
    errorCount: 0,
    successCount: 0,
    batchOutGUID: "",
    process_flg: false,
    batchOutOrders: [],
    batchOutOrderLength: 0,
    alreadyOutedOrderLength: 0,
    batchOutDialog: false,
    batchOutInfoDialog: false,
    batchOutInfo: i18n.t("StockOrderOUT.Messages.batchOutWait"),
    districtsSelected: [],
    deliveryPointSelected: null,
    distributionUserSelected: null,
    shopsSelected: [],
    shopKeyword: "",
    stockDistrictSelected: null,
    materialSelected: [],
    materialCategoriesSelected: [],
    partOutDialog: false,
    part_stock_outs: [],
    lastStockOutTypeSelected: null, //上次出库类型搜索选择
    outRecallDialog: false,
  }),

  methods: {
    resetSearch() {
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];

      this.stockOutTypeSelected = null;
      this.stockOutBrokenTypeSelected = null;
      this.shopsSelected = [];
      this.stocksSelected = [];
      this.requisitionStocksSelected = [];
      this.districtsSelected = [];
      this.materialSelected = [];
      this.materialCategoriesSelected = [];
      this.stockSelected = null;
      this.deliveryPointSelected = null;
      this.distributionUserSelected = null;
      this.stockDistrictSelected = null;
      //重置options
      this.options = JSON.parse(JSON.stringify(getDefaultOptions()));
      //重置搜索框
      let clearArr = [this.$refs.stock_order_code];
      if (getPageType() != 3) {
        clearArr.push(this.$refs.ext_code);
        clearArr.push(this.$refs.shop_keyword);
      }
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockOutsKeyWord,
        shop_keyword: this.shopKeyword,
      });
    },
    getStockOutsFromAPI() {
      var newOptions = {};
      // 因三个页面共用这一个页面，options在三个页面切换时不能够监测响应到内部键值对的变化，
      // 所以在调用接口前与相应页面的default_option做对比，过滤掉多余的键值对，并重新存入session
      var dfOptions = getDefaultOptions();
      for (let key in this.options) {
        if (
          (dfOptions && typeof dfOptions[key] != "undefined") ||
          typeof this.$consts.tableOptions[key] != "undefined"
        ) {
          newOptions[key] = this.options[key];
        }
      }
      sessionStorage.setItem(
        getOptionPrefix() + "-options",
        JSON.stringify(newOptions)
      );
      if (getPageType() == 1 && this.stockOutTypeSelected == 1) {
        //普通出库页面，如果条件勾选了“要货出库”类型，status条件不能包含“待审批”
        if (newOptions.status && newOptions.status.find((s) => s == 1))
          newOptions.status.splice(
            newOptions.status.findIndex((s) => s == 1),
            1
          );
      }

      if (
        newOptions.datetimeRadioSelected &&
        newOptions.datetimeRadioSelected == "actual"
      ) {
        newOptions.actual_date_from = this.options.actual_time_from;
        newOptions.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.fetch(newOptions).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_outs;
            this.paging = response.data.paging;
            let batchOutOrders = [];
            this.stock_outs.forEach((order) => {
              //取可出库的单子
              if (order.actions.out_complete) {
                batchOutOrders.push(order);
              }
            });
            this.batchOutOrders = batchOutOrders;
            this.batchOutOrderLength = batchOutOrders.length;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    completePackConfirm(stockOutInfo) {
      StockOuts.submitPackConfirm({
        stock_id: stockOutInfo.stock_id,
        stock_order_code: stockOutInfo.stock_order_code,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStockOutsFromAPI();
            this.$store.commit("refreshToDos", true);
          }
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (
            this.options.datetimeRadioSelected &&
            this.options.datetimeRadioSelected == "actual"
          ) {
            this.options.actual_date_from = this.options.actual_time_from;
            this.options.actual_date_to = this.options.actual_time_to;
          }
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          var path = null;
          switch (mode) {
            case "distributionPrint":
              path = "/print/stock-orders-out-distribution-print";
              break;
            case "distributionsMergePrint":
              path = "print/stock-order-out-distributions-merge-print";
              break;
            case "stockOUTOrdersPrint":
              path = "/print/stock-orders-out-print";
              break;
            case "stockOUTOrdersMergePrint":
              path = "/print/stock-orders-out-merge-print";
              break;
            case "stockOUTOrdersMergePrintPreview":
              path = "/print/stock-orders-out-merge-print-preview";
              break;
            case "requisitionOutMergePrint":
              path = "/print/requisition-out-merge-print";
              break;
            case "requisitionOutMergePrintPreview":
              path = "/print/requisition-out-merge-print-preview";
              break;
          }
          if (path) this.$router.push({ path: path, query: options });
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (
            this.options.datetimeRadioSelected &&
            this.options.datetimeRadioSelected == "actual"
          ) {
            this.options.actual_date_from = this.options.actual_time_from;
            this.options.actual_date_to = this.options.actual_time_to;
          }
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          if (mode == "distribution") {
            //获取单据详情
            StockOuts.distributionsPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let distributions = [];
                  response.data.stock_outs.forEach((stock_out) => {
                    if (stock_out.distribution) {
                      stock_out.order.shop = this.$printUtils.addCitiesName(
                        stock_out.order.shop
                      );
                      let result = {
                        order: stock_out.order,
                        distribution: Object.assign(
                          {},
                          stock_out,
                          makeData.processDetails(stock_out.distribution)
                        ),
                        order_address: stock_out.order_address,
                      };
                      if (stock_out.stock_id) {
                        result.stock_id = stock_out.stock_id;
                      }
                      distributions.push(result);
                    }
                  });
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: distributions,
                  });
                }
              }.bind(this)
            );
          } else if (mode == "commonShopDistribution") {
            if (options.status && options.status.find((s) => s == 1)) {
              options.status.splice(
                options.status.findIndex((s) => s == 1),
                1
              );
            }
            StockOuts.distributionsMergePrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  response.data.stock_outs.forEach((stock_out) => {
                    stock_out.shop = this.$printUtils.addCitiesName(
                      stock_out.shop
                    );
                    CloudPrintTemplates.print({
                      print_template_code: mode,
                      object: makeData.processDetails(stock_out),
                    });
                  });
                }
              }.bind(this)
            );
          } else if (mode == "stockOrderOut") {
            //获取单据详情
            StockOuts.stockOrdersOutPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stockOrdersOut = response.data.stock_outs;
                  if (stockOrdersOut) {
                    stockOrdersOut.forEach((stockOrderOut) => {
                      let object = makeData.processDetails(stockOrderOut);
                      let printData = {
                        print_template_code: mode,
                        object: object,
                      };
                      if (object && object.stock_id) {
                        printData.stock_id = object.stock_id;
                      }
                      CloudPrintTemplates.print(printData);
                    });
                  }
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    batchOut(options) {
      StockOuts.batchOut(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.guid) {
              // 成功加入队列
              this.batchOutGUID = response.data.guid;
              this.process_flg = true;
              intervalRef = setInterval(() => {
                if (this.process_flg) {
                  this.getBatchOutProcess();
                }
              }, 1000);
            } else {
              // 没有符合条件的出库任务
              this.batchOutGUID = "";
              this.batchOutInfo = i18n.t("StockOrderOUT.Messages.noBatchOut");
              this.$snackbar.success(
                i18n.t("StockOrderOUT.Messages.noBatchOut")
              );
            }
          }
        }.bind(this)
      );
    },

    getBatchOutProcess() {
      if (this.batchOutGUID != "") {
        StockOuts.getBatchOutProcess(this.batchOutGUID).then(
          function (processResponse) {
            if (processResponse.data.status.isOK()) {
              this.batchOutInfo = i18n.t(
                "StockOrderOUT.Messages.batchOutInfo",
                [
                  processResponse.data.succeed_count,
                  processResponse.data.fail_count,
                ]
              );
              if (processResponse.data.wait_count == 0) {
                this.$snackbar.success(
                  i18n.t("StockOrderOUT.Messages.batchOutSuccess")
                );
                this.process_flg = false;
                this.batchOutGUID = "";
                this.getStockOutsFromAPI();
                this.$store.commit("refreshToDos", true);
              }
            }
          }.bind(this)
        );
      }
    },
    batchExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.batchExport(this.options);
    },
    batchDetailPriceSubAccountExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.batchDetailPriceSubAccountExport(this.options);
    },
    batchDistributionsExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.batchDistributionsExport(this.options);
    },
    shopMergeExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.shopMergeExport(this.options);
    },
    materialMergeExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.materialMergeExport(this.options);
    },
    disUserMergeExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.disUserMergeExport(this.options);
    },
    routerPickingOut() {
      let stock_id = {};
      if (getPageType() == 1) {
        stock_id = this.stocksSelected[0];
      } else if (getPageType() == 2) {
        stock_id = this.stockSelected;
      }
      let datetimeRadioSelected = "";
      if (
        this.options.datetimeRadioSelected == "created" ||
        this.options.datetimeRadioSelected == "actual"
      ) {
        datetimeRadioSelected = this.options.datetimeRadioSelected;
      }
      sessionStorage.setItem(
        "picking-out-old-search",
        JSON.stringify({
          options: this.options,
          stock_id: stock_id,
          category_codes: this.materialCategoriesSelected,
          material_ids: this.materialSelected,
          shop_ids: this.shopsSelected,
          district_ids: this.districtsSelected,
          delivery_point_id: this.deliveryPointSelected,
          old_path: getOptionPrefix(),
        })
      );
      sessionStorage.setItem(
        "stock-orders-picking-out-options",
        JSON.stringify({
          datetimeRadioSelected: datetimeRadioSelected,
          created_time_from: this.options.created_time_from,
          created_time_to: this.options.created_time_to,
          actual_time_from: this.options.actual_time_from,
          actual_time_to: this.options.actual_time_to,
          stock_ids: null,
          category_codes: [],
          material_ids: [],
          shop_ids: [],
          district_ids: [],
          distribution_user_id: [],
          sorting_status: [],
          type: 1,
          status: [2],
          cancel_flgs: [0],
          delivery_point_id: null,
        })
      );
      this.$router.push("/stock-orders-out/picking-out");
    },
    routerManualSplit() {
      let stock_id = {};
      if (getPageType() == 1) {
        stock_id = this.stocksSelected[0];
      } else if (getPageType() == 2) {
        stock_id = this.stockSelected;
      }
      sessionStorage.setItem(
        "picking-out-old-search",
        JSON.stringify({
          options: this.options,
          stock_id: stock_id,
          category_codes: this.materialCategoriesSelected,
          material_ids: this.materialSelected,
          shop_ids: this.shopsSelected,
          district_ids: this.districtsSelected,
          delivery_point_id: this.deliveryPointSelected,
          old_path: getOptionPrefix(),
        })
      );
      this.$router.push("/stock-orders-out/manual-split");
    },
    getPartOutRelations() {
      StockOuts.getPartOutRelations(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.part_stock_outs = response.data.stock_outs;
          }
        }.bind(this)
      );
    },
    batchOutNumRecall() {
      StockOuts.batchOutNumRecall().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("StockOrderOUT.Messages.outRecallSuccess")
            );
          }
        }.bind(this)
      );
    },
    requisitionMergeExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.requisitionMergeExport(this.options);
    },
    sortingMaterialMergeExport() {
      if (
        this.options.datetimeRadioSelected &&
        this.options.datetimeRadioSelected == "actual"
      ) {
        this.options.actual_date_from = this.options.actual_time_from;
        this.options.actual_date_to = this.options.actual_time_to;
      }
      StockOuts.sortingMaterialMergeExport(this.options);
    },
  },

  mounted() {
    this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.created_time_from != "undefined" &&
            typeof this.options.created_time_to != "undefined"
          )
            this.datetimeRage = [
              this.options.created_time_from,
              this.options.created_time_to,
            ];
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "materialSelected": //商品条件三个页面都有
              this.materialSelected = selected.value;
              break;
            case "stockSelected": //仓库条件两个页面有
              if (getPageType() == 3 || getPageType() == 2)
                this.stockSelected = selected.value;
              break;
            case "stocksSelected":
              if (getPageType() == 1) this.stocksSelected = selected.value;
              break;
            case "requisitionStocksSelected" :
              if (
                  getPageType() == 1 &&
                  data.selecteds.find(
                      (selected) => selected.key == "stockOutTypeSelected"
                  ).value == 2
              ) {
                this.requisitionStocksSelected = selected.value;
              }
              break;
            case "distributionUserSelected":
              if (
                getPageType() == 2 ||
                (getPageType() == 1 &&
                  data.selecteds.find(
                    (selected) => selected.key == "stockOutTypeSelected"
                  ).value == 1)
              )
                this.distributionUserSelected = selected.value;
              break;
            case "stockDistrictSelected":
              if (getPageType() == 2)
                this.stockDistrictSelected = selected.value;
              break;
            case "districtsSelected":
              if (
                getPageType() == 2 ||
                (getPageType() == 1 &&
                  data.selecteds.find(
                    (selected) => selected.key == "stockOutTypeSelected"
                  ).value == 1)
              )
                this.districtsSelected = selected.value;
              break;
            case "deliveryPointSelected":
              if (
                getPageType() == 2 ||
                (getPageType() == 1 &&
                  data.selecteds.find(
                    (selected) => selected.key == "stockOutTypeSelected"
                  ).value == 1 &&
                  this.settings &&
                  this.settings.delivery_point)
              )
                this.deliveryPointSelected = selected.value;
              break;
            case "shopsSelected":
              if (
                getPageType() == 2 ||
                (getPageType() == 1 &&
                  data.selecteds.find(
                    (selected) => selected.key == "stockOutTypeSelected"
                  ).value == 1)
              )
                this.shopsSelected = selected.value;
              break;
            case "stockOutTypeSelected":
              if (getPageType() == 1)
                this.stockOutTypeSelected = selected.value;
              break;
            case "stockOutBrokenTypeSelected":
              if (
                getPageType() == 1 &&
                data.selecteds.find(
                  (selected) => selected.key == "stockOutTypeSelected"
                ).value == 11
              )
                this.stockOutBrokenTypeSelected = selected.value;
              break;
            case "materialCategoriesSelected":
              if (
                getPageType() != 3 &&
                (data.selecteds.find(
                  (selected) => selected.key == "stockOutTypeSelected"
                ).value == 1 ||
                  getPageType() == 2)
              )
                this.materialCategoriesSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  watch: {
    $route: {
      handler() {
        this.pageType = getPageType();
        this.$commonUtils
          .loadOptions(getOptionPrefix(), getOptionSelects())
          .then(
            function (data) {
              if (data.options) {
                this.options = data.options;
                if (
                  typeof this.options.created_time_from != "undefined" &&
                  typeof this.options.created_time_to != "undefined"
                )
                  this.datetimeRage = [
                    this.options.created_time_from,
                    this.options.created_time_to,
                  ];
              } else this.resetSearch();

              data.selecteds.forEach((selected) => {
                switch (selected.key) {
                  case "materialSelected": //商品条件三个页面都有
                    this.materialSelected = selected.value;
                    break;
                  case "stockSelected": //仓库条件两个页面有
                    if (getPageType() == 3 || getPageType() == 2)
                      this.stockSelected = selected.value;
                    break;
                  case "stocksSelected":
                    if (getPageType() == 1)
                      this.stocksSelected = selected.value;
                    break;
                  case "requisitionStocksSelected" :
                    if (
                        getPageType() == 1 &&
                        data.selecteds.find(
                            (selected) => selected.key == "stockOutTypeSelected"
                        ).value == 2
                    ) {
                      this.requisitionStocksSelected = selected.value;
                    }
                    break;
                  case "distributionUserSelected":
                    if (
                      getPageType() == 2 ||
                      (getPageType() == 1 &&
                        data.selecteds.find(
                          (selected) => selected.key == "stockOutTypeSelected"
                        ).value == 1)
                    )
                      this.distributionUserSelected = selected.value;
                    break;
                  case "stockDistrictSelected":
                    if (getPageType() == 2)
                      this.stockDistrictSelected = selected.value;
                    break;
                  case "districtsSelected":
                    if (
                      getPageType() == 2 ||
                      (getPageType() == 1 &&
                        data.selecteds.find(
                          (selected) => selected.key == "stockOutTypeSelected"
                        ).value == 1)
                    )
                      this.districtsSelected = selected.value;
                    break;
                  case "deliveryPointSelected":
                    if (
                      getPageType() == 2 ||
                      (getPageType() == 1 &&
                        data.selecteds.find(
                          (selected) => selected.key == "stockOutTypeSelected"
                        ).value == 1 &&
                        this.settings &&
                        this.settings.delivery_point)
                    )
                      this.deliveryPointSelected = selected.value;
                    break;
                  case "shopsSelected":
                    if (
                      getPageType() == 2 ||
                      (getPageType() == 1 &&
                        data.selecteds.find(
                          (selected) => selected.key == "stockOutTypeSelected"
                        ).value == 1)
                    )
                      this.shopsSelected = selected.value;
                    break;
                  case "stockOutTypeSelected":
                    if (getPageType() == 1)
                      this.stockOutTypeSelected = selected.value;
                    break;
                  case "stockOutBrokenTypeSelected":
                    if (
                      getPageType() == 1 &&
                      data.selecteds.find(
                        (selected) => selected.key == "stockOutTypeSelected"
                      ).value == 11
                    )
                      this.stockOutBrokenTypeSelected = selected.value;
                    break;
                  case "materialCategoriesSelected":
                    if (
                      getPageType() != 3 &&
                      (data.selecteds.find(
                        (selected) => selected.key == "stockOutTypeSelected"
                      ).value == 1 ||
                        getPageType() == 2)
                    )
                      this.materialCategoriesSelected = selected.value;
                    break;
                }
              });
            }.bind(this)
          );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getStockOutsFromAPI();
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        if (getPageType() == 1) {
          this.options.category_codes = this.materialCategoriesSelected
            ? this.materialCategoriesSelected.map((e) => {
                return e.code;
              })
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-materialCategoriesSelected",
            JSON.stringify(this.materialCategoriesSelected)
          );
        } else {
          this.options.category_codes = null;
        }
      },
    },
    stockOutTypeSelected: {
      handler() {
        if (getPageType() == 1) {
          this.options.type = this.stockOutTypeSelected
            ? this.stockOutTypeSelected
            : null;
          sessionStorage.setItem(
            getOptionPrefix() + "-stockOutTypeSelected",
            JSON.stringify(this.stockOutTypeSelected)
          );
          if (this.stockOutTypeSelected != 1) {
            this.districtsSelected = [];
            this.deliveryPointSelected = [];
            this.shopsSelected = [];
            this.distributionUserSelected = null;
            this.materialCategoriesSelected = [];
            this.options.presale_flgs = [0, 1];
            this.requisitionStocksSelected = [];
            this.options.requisition_to_stock_ids = null;
            this.stockOutBrokenTypeSelected = [];
            this.options.broken_type = null;
            // 切换出库类型时，出库单状态恢复全选
            if (this.lastStockOutTypeSelected == 1) {
              if (this.options.status.findIndex((s) => s == 1) == -1)
                this.options.status.unshift(1);
            }
            this.lastStockOutTypeSelected = this.stockOutTypeSelected;
          } else {
            this.lastStockOutTypeSelected = 1;
          }
        } else {
          this.options.type = null;
        }
      },
    },
    stockOutBrokenTypeSelected: {
      handler() {
        if (getPageType() == 1) {
          this.options.broken_type = this.stockOutBrokenTypeSelected
            ? this.stockOutBrokenTypeSelected
            : null;
          sessionStorage.setItem(
            getOptionPrefix() + "-stockOutBrokenTypeSelected",
            JSON.stringify(this.stockOutBrokenTypeSelected)
          );
        }
      },
    },
    requisitionStocksSelected: {
      handler() {
        if (getPageType() == 1 && this.stockOutTypeSelected && this.stockOutTypeSelected == 2) {
          this.options.requisition_to_stock_ids = this.requisitionStocksSelected
              ? this.requisitionStocksSelected.map((e) => {
                return e.id;
              })
              : null;
          sessionStorage.setItem(
              getOptionPrefix() + "-requisitionStocksSelected",
              JSON.stringify(this.requisitionStocksSelected)
          );
        } else {
          this.options.requisition_to_stock_ids = null;
        }
      }
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.distributionUserSelected = null;
        if (getPageType() == 1) {
          this.options.stock_ids = this.stocksSelected
            ? this.stocksSelected.map((e) => {
                return e.id;
              })
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-stocksSelected",
            JSON.stringify(this.stocksSelected)
          );
        } else {
          this.options.stock_ids = "";
        }
      },
    },
    stockSelected: {
      handler() {
        if (getPageType() == 2 || getPageType() == 3) {
          this.options.stock_ids = this.stockSelected
            ? this.stockSelected.id
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-stockSelected",
            JSON.stringify(this.stockSelected)
          );
        } else {
          this.options.stock_ids = "";
        }
      },
    },
    // 分组查询
    districtsSelected: {
      handler() {
        if (
          getPageType() == 2 ||
          (getPageType() == 1 && this.stockOutTypeSelected == 1)
        ) {
          this.options.district_ids = this.districtsSelected
            ? this.districtsSelected.map((e) => {
                return e.id;
              })
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-districtsSelected",
            JSON.stringify(this.districtsSelected)
          );
        } else {
          this.options.district_ids = "";
        }
      },
    },
    // 配送点查询
    deliveryPointSelected: {
      handler() {
        if (
          (getPageType() == 2 ||
            (getPageType() == 1 && this.stockOutTypeSelected == 1)) &&
          this.settings &&
          this.settings.delivery_point
        ) {
          this.options.delivery_point_id = this.deliveryPointSelected
            ? this.deliveryPointSelected.id
            : null;
          sessionStorage.setItem(
            getOptionPrefix() + "-deliveryPointSelected",
            JSON.stringify(this.deliveryPointSelected)
          );
        } else {
          this.options.delivery_point_id = null;
        }
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 配送路线
    distributionUserSelected: {
      handler() {
        if (
          getPageType() == 2 ||
          (getPageType() == 1 && this.stockOutTypeSelected == 1)
        ) {
          this.options.distribution_user_id = this.distributionUserSelected
            ? this.distributionUserSelected.id
            : null;
          sessionStorage.setItem(
            getOptionPrefix() + "-distributionUserSelected",
            JSON.stringify(this.distributionUserSelected)
          );
        } else {
          this.options.distribution_user_id = null;
        }
      },
    },
    // 客户选择
    shopsSelected: {
      handler() {
        if (
          getPageType() == 2 ||
          (getPageType() == 1 && this.stockOutTypeSelected == 1)
        ) {
          this.options.shop_ids = this.shopsSelected
            ? this.shopsSelected.map((alliance) => {
                return alliance.id;
              })
            : "";
          sessionStorage.setItem(
            getOptionPrefix() + "-shopsSelected",
            JSON.stringify(this.shopsSelected)
          );
        } else {
          this.options.shop_ids = "";
        }
      },
    },
    // 仓库分组
    stockDistrictSelected: {
      handler() {
        if (getPageType() == 2) {
          this.options.stock_district_id = this.stockDistrictSelected
            ? this.stockDistrictSelected.id
            : null;
          sessionStorage.setItem(
            getOptionPrefix() + "-stockDistrictSelected",
            JSON.stringify(this.stockDistrictSelected)
          );
        } else {
          this.options.stock_district_id = null;
        }
      },
    },
    batchOutInfoDialog: {
      handler() {
        if (!this.batchOutInfoDialog) {
          this.batchOutInfo = i18n.t("StockOrderOUT.Messages.batchOutWait");
        }
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>